import { Feedbacks } from "@/blocks/Feedbacks";
import {
  CsatScore,
  getCsatRating,
  getCsatRatingTextColor,
} from "@/components/CsatScore";

import { PlaygroundSectionLayout } from "../PlaygroundSectionLayout";
import { PlaygroundSubSectionLayout } from "../PlaygroundSubSectionLayout";
import { PlaygroundSubSectionTitle } from "../PlaygroundSubSectionTitle";

const RATING_LABEL = {
  high: "High",
  medium: "Medium",
  low: "Low",
  na: "N/A",
};

const noop = () => {};

function ScoreRow({ score }: { score: number }) {
  const rating = getCsatRating(score);

  return (
    <div className="flex items-center gap-4">
      <div className="flex items-center gap-2">
        <CsatScore value={score} />
        <span
          className={`text-sm font-semibold ${getCsatRatingTextColor(rating)}`}
        >
          {RATING_LABEL[rating]}
        </span>
      </div>
      <Feedbacks onClickThumbUp={noop} onClickThumbDown={noop} />
    </div>
  );
}

export function PlaygroundCsatScoreRow() {
  return (
    <PlaygroundSectionLayout>
      <PlaygroundSubSectionLayout>
        <PlaygroundSubSectionTitle>
          Score row (tag + rating + feedback)
        </PlaygroundSubSectionTitle>
        <div className="flex flex-col gap-6">
          <ScoreRow score={28} />
          <ScoreRow score={52} />
          <ScoreRow score={78} />
        </div>
      </PlaygroundSubSectionLayout>
    </PlaygroundSectionLayout>
  );
}
